<template>
  <settings-list
    :name-header-text="$i18n.t('label.tag')"
    :store-entities="$tstore.state.settings.tagNotes"
    :on-save="save"
    :on-add="add"
    :on-is-changed-change="isChangedChange"
    :no-data-text="$t('label.no_tags')"
  />
</template>

<script lang="ts">
import Vue from 'vue';
import UnsavedGuard from '@/mixins/unsaved-guard';
import SettingsList from '@/components/views/settings/SettingsList.vue';
import TagNote from '@/model/TagNote';

export default Vue.extend({
  name: 'TagNotes',
  components: { SettingsList },
  mixins: [UnsavedGuard],
  data() { return { changed: false }; },
  computed: {
    // eslint-disable-next-line vue/no-unused-properties
    isChanged(): boolean { return this.changed; },
  },
  methods: {
    async save(entities: TagNote[]) { await this.$tstore.dispatch('sendTagNotes', { entities }); },
    add(): TagNote { return new TagNote(); },
    isChangedChange(changed: boolean) { this.changed = changed; },
  },
});

</script>
